import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import LinkColorOnActive from "../../assets/images/icons/LinkColorOnActive";
import moment from "moment";
import { useState } from "react";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as ViewIcon } from "../../assets/images/view_eye_icon.svg";
import { ReactComponent as PDF } from "../../assets/images/icons/PDF.svg";
import { ReactComponent as DownloadIcon } from "../../assets/images/icons/DownloadedIcon.svg";
import { getSentenceCase, getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import { getDateYYYYMMDD } from "../../utils/utilityFunctions/dateConvert";

const LinkedDocsCard = ({
  info,
  key,
  isAddButtonActive,
  handleUnlinkDocument,
  handleLinkDocument,
  folderIconList,
  highlightText = () => {},
  searchText,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLinkUnlinked = async () => {
    try {
      setIsLoading(() => true);
      if (isAddButtonActive) {
        await handleLinkDocument(info);
      } else {
        await handleUnlinkDocument(info);
      }
    } catch (error) {
      console.log(error?.message);
    } finally {
      setIsLoading(() => false);
    }
  };

  const downloadFile = async (file) => {
    const url = `${file}`;

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  console.log(info, "vianyInfo");
  return (
    <div key={key} className="flex gap-1">
      <div className="flex flex-col justify-between border-b border-[#D2DAE1] grow min-h-0 p-3 gap-1">
        <div className="flex  gap-2">
          <div className="p-1 flex">
            <PDF />
          </div>
          <div>
            <h1 className="text-sm text-[#1D4469] font-medium">
              {highlightText(
                info?.display_name?.length > 25
                  ? getTitleCase(info?.document_name)?.slice(0, 25) + "..."
                  : getTitleCase(info?.document_name),
                searchText
              )}
            </h1>
            <span className="text-xs text-[#38383899] font-normal">
              {highlightText(
                `Created By: ${getTitleCase(info?.created_by)} | ${getDateYYYYMMDD(info?.created_at)}`,
                searchText
              )}
            </span>
          </div>
        </div>
        <div className="flex justify-centre items-start ml-6 gap-3">
          <button className="text-blue-500 hover:text-blue-700" onClick={() => downloadFile(info?.view_url)}>
            <i className="bi bi-eye text-14"></i>
          </button>

          <button className="text-blue-500 hover:text-blue-700" onClick={() => downloadFile(info?.download_url)}>
            <i className="bi bi-download text-12"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkedDocsCard;
